import { SectionLoader } from '@/shared/components/section-loader';

export const AdminShiftsListLoading = () => {
  return <SectionLoader />;
};
